$(async function() {
  console.log('Shipping date script started');

  // Check if jQuery is loaded
  if (typeof $ === 'undefined') {
    console.error('jQuery is not loaded!');
    return;
  }

  // Check if shipping dates variable exists
  if (typeof all_ship_dates2 === 'undefined') {
    console.error('all_ship_dates2 is undefined!');
    return;
  } else {
    console.log('all_ship_dates2 found:', all_ship_dates2);
  }

  const currentDate = new Date();
  console.log('Current date:', currentDate);

  // Get UTC date
  const currentUTCDate = new Date(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate(),
    currentDate.getUTCHours(),
    currentDate.getUTCMinutes()
  );
  console.log('Current UTC date:', currentUTCDate);

  // EST time
  const estDate = new Date(currentUTCDate.getTime() - (4 * 60 * 60 * 1000));
  console.log('EST date:', estDate);

  // 5 PM EST
  const fivePMEST = new Date(estDate.getFullYear(), estDate.getMonth(), estDate.getDate(), 17, 0, 0);
  console.log('5 PM EST today:', fivePMEST);

  let closestDate = null;
  let closestDateDiff = null;

  // Loop through all_ship_dates2
  for (let i = 0; i < all_ship_dates2.length; i++) {
    if (all_ship_dates2[i] !== undefined) {
      const shipDateParts = all_ship_dates2[i].ship_date.split('-').map(Number);
      const cutoffDateParts = all_ship_dates2[i].cutoff_date.split('-').map(Number);
      console.log(`Checking ship date ${all_ship_dates2[i].ship_date} with cutoff ${all_ship_dates2[i].cutoff_date}`);

      const upcomingDate = new Date(shipDateParts[0], shipDateParts[1] - 1, shipDateParts[2]);
      const upcomingDateCut = new Date(cutoffDateParts[0], cutoffDateParts[1] - 1, cutoffDateParts[2]);

      const diff = upcomingDate - currentUTCDate;
      const diffCut = upcomingDateCut - currentUTCDate;

      const isBeforeCutoffToday =
        cutoffDateParts[0] === estDate.getFullYear() &&
        cutoffDateParts[1] === estDate.getMonth() + 1 &&
        cutoffDateParts[2] === estDate.getDate() &&
        estDate < fivePMEST;

      const isAfterToday = diffCut > 0 || isBeforeCutoffToday;
      console.log('diff:', diff, 'diffCut:', diffCut, 'isAfterToday:', isAfterToday);

      if (diff > 0 && (closestDateDiff === null || diff < closestDateDiff) && isAfterToday) {
        closestDate = upcomingDate;
        closestDateDiff = diff;
        const orderDays = Math.floor((upcomingDateCut - currentDate) / (1000 * 60 * 60 * 24));
        console.log('Closest date found:', closestDate, 'Order days:', orderDays);

        if (orderDays <= 0) {
          $('.ship-date--days').html('now');
        } else {
          if ($('.ship-date--days').length > 0) {
            $('.ship-date--days').html('in the next ' + orderDays + ' days');
          }
        }
        break;
      }
    }
  }

  if (!closestDate) {
    console.warn('No upcoming ship date found!');
    return;
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const formattedDate = formatter.format(closestDate);
  console.log('Formatted date before suffix:', formattedDate);

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  const [month, day, year] = formattedDate.split(' ');
  const dayWithSuffix = parseInt(day) + getOrdinalSuffix(parseInt(day));
  const finalFormattedDate = `${month.toUpperCase()} ${dayWithSuffix}, ${year}`;
  console.log('Final formatted date:', finalFormattedDate);

  if ($('.ship-date-inline').length > 0) {
    $(".ship-date-inline").html(finalFormattedDate);
  } else {
    console.error('.ship-date-inline element not found!');
  }
});
